import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button
} from '@mui/material';

const themes = [
  { id: 1, name: 'Family', image: '/images/family.jpg' },
  { id: 2, name: 'Pilgrimage', image: '/images/pilgrimage.jpg' },
  { id: 3, name: 'Friends', image: '/images/friends.jpg' },
  { id: 4, name: 'Nature', image: '/images/nature.jpg' },
  { id: 5, name: 'Mountains', image: '/images/mountain.jpg' },
  { id: 6, name: 'Honeymoon', image: '/images/honeymoon.jpg' },
  { id: 7, name: 'Beaches', image: '/images/beaches.jpg' },
];

const TravelByTheme = () => {
  return (
    <Box sx={{  py: 6 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          fontSize: '2rem',
          mb: 4,
          textAlign: 'center',
          letterSpacing: 1,
        }}
      >
        TRAVEL BY THEME
      </Typography>

      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        {themes.map((theme) => (
          <Grid item xs={12} sm={6} md={3} key={theme.id}>
            <Box
              sx={{
                width: 300,
                height: 300,
                perspective: 1000,
                mx: 'auto',
              }}
            >
              <Card
                sx={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 4,
                  overflow: 'hidden',
                  position: 'relative',
                  transition: 'transform 0.5s',
                  transformStyle: 'preserve-3d',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                  '&:hover': {
                    transform: 'rotateY(6deg) scale(1.03)',
                  },
                  '&:hover .overlay': {
                    opacity: 1,
                    transform: 'translateY(0)',
                  },
                  '&:hover .image': {
                    transform: 'scale(1.08)',
                    filter: 'blur(3px)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={theme.image}
                  alt={theme.name}
                  className="image"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'all 0.5s ease',
                    filter: 'blur(0)',
                  }}
                />

                <CardContent
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    textAlign: 'center',
                    background: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    py: 1,
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    letterSpacing: 0.5,
                  }}
                >
                  {theme.name}
                </CardContent>

                <Box
                  className="overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.4)',
                    opacity: 0,
                    transform: 'translateY(20px)',
                    transition: 'all 0.4s ease-in-out',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    letterSpacing: 1,
                    cursor: 'pointer',
                  }}
                  onClick={() => window.location.href = 'themes/' + theme.name}
                >
                   <Button
                    variant="contained"
                    sx={{
                      backgroundColor: '#0e8279',
                      color: '#fff',
                      fontWeight: 'bold',
                      px: 3,
                      py: 1.2,
                      borderRadius: 3,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                      fontSize: '0.9rem',
                      transition: 'all 0.3s',
                      '&:hover': {
                        backgroundColor: '#0e8279',
                        transform: 'scale(1.05)',
                      },
                    }}
                    onClick={()=> window.location.href= 'themes/'+theme.name}
                  >
                    View Packages
                  </Button>
                </Box>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TravelByTheme;
